<dx-popup
    #notesPopup
    *ngIf="visible"
    minWidth="150px"
    minHeight="150px"
    width="30%"
    height="50%"
    title="Notes For Vendor Account #{{ accountNumber }}"
    [showCloseButton]="true"
    [shading]="false"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [visible]="visible"
    (onShown)="onVendorAccountNotesPopupShown()"
    (onHidden)="onVendorAccountNotesPopClose()"
>
    <div *dxTemplate="let data of 'content'">
        <app-notes-editor
            #vendorAccountNotes
            [(previousNotes)]="previousVendorAccountNotes"
            [previousNotesVisible]="true"
            (onNotesPopUpClose)="onVendorAccountNotesPopClose()"
            (onNewNotesSave)="onSaveVendorAccountNotes($event)"
        ></app-notes-editor>
    </div>
</dx-popup>
